import React from "react";
import { Avatar, Heading, Text, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";

const greeting = "Hello, I am Mustafa!";
const bio1 = "Unity & Mobile Developer";
const bio2 = "Mobile developer working with Kotlin, Kotlin Multiplatform, Unity, and Express.js.";
const getImageSrc = () => require("../images/1723159540532.jpg")

// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Avatar, Heading and VStack components.
const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    fullHeight
    backgroundColor="#081827"
    backgroundImage="radial-gradient(circle at 78% 22%, rgba(45, 212, 191, 0.16), transparent 24%), radial-gradient(circle at 20% 82%, rgba(59, 130, 246, 0.22), transparent 28%)"
    textAlign="center"
    padding={{ base: 8, md: 12 }}
  >
    <VStack spacing={5} maxWidth="760px">
      <Avatar src={getImageSrc()} size="xl" border="3px solid" borderColor="teal.200" />
      <Text color="teal.200" fontWeight="semibold">{greeting}</Text>
      <Heading as="h1" size={{ base: "xl", md: "2xl" }} lineHeight="1.15">
        {bio1}
      </Heading>
       <Text color="whiteAlpha.800" fontSize={{ base: "md", md: "lg" }} lineHeight="1.75">
        {bio2}
      </Text> 
    </VStack>
  </FullScreenSection>
);

export default LandingSection;
